export const name: string = 'Action Button';
export const group = 'Misc.';
export const moduleName: string = 'pdc-widget-action-button';
export const icon: string = 'flash';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'pdc-widget-action-button';

export const themeFields = {
    promptDialogTitile: 'widget-action-button-prompt-dialog-title',
    promptDialogText: 'widget-action-button-prompt-dialog-text'
}